<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Referral/Consultation/Medical Assessment
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="transplantProgram"
              class="transplantProgram"
              disabled
              label="Transplant Program"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="recipientCoordinator"
              disabled
              label="Recipient Coordinator"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="primaryDiagnosis"
              disabled
              label="Primary Diagnosis"
            />
          </div>
        </div>
    
        <!-- <div class="row">
        <div class="col-4">
          Urgent Listing :
        </div> <div class="col-4">
          <input
            
            class="inputDisplay"
            disabled
          >
        </div> 
      </div> -->
        <!-- <div class="row">
        <div class="col-4">
          Referred With :
        </div> <div class="col-4">
          <input
            
            class="inputDisplay"
            disabled
          >
        </div> 
      </div> -->
        <!-- <div class="row">
        <div class="col-4">
          Referral Received Date :
        </div> <div class="col-4">
          <input
            v-model="referralReceivedDate"
            class="inputDisplay"
            disabled
          >
        </div> 
      </div>
      <div class="row">
        <div class="col-4">
          MRN  :
        </div> <div class="col-4">
          <input
            
            class="inputDisplay"
            disabled
          >
        </div> 
      </div> -->
        <!-- <div class="row">
        <div class="col-4">
          Referral ID  :
        </div> <div class="col-4">
          <input
            
            class="inputDisplay"
            disabled
          >
        </div> 
      </div> -->

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="primaryDiagnosisDate"
              disabled
              label="Primary Diagnosis Date"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="referringOrganizationName"
              disabled
              label="ReferringOrganizationName"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="referringOrganizationType"
              disabled
              label="Referring Organization Type"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="otherOrganizationType"
              class="otherOrganizationType"
              disabled
              label="Other Organization Type"
            />
          </div>

          <div class="col-3">
            <ADSTextInput
              v-model="referringHealthCareProfessionalType"
              disabled
              label="Referring Health Care Professional Type"
            />
          </div>

          <!-- <div class="col-5">
            <ADSTextInput
              v-model="careTeamID"
              class="careTeamID"
              disabled
              label="CareTeamID"
            />
          </div> -->
        </div>

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="firstName"
              disabled
              label="First Name"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="lastName"
              disabled
              label="Last Name"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="address"
              disabled
              label="Office Street Address"
            />
          </div>
        </div>

        <!-- <div class="row">
        <div class="col-4">
          Secondary Diagnosis :
        </div> <div class="col-4">
          <input
            
            class="inputDisplay"
            disabled
          >
        </div> 
      </div>
      <div class="row">
        <div class="col-4">
          Secondary Diagnosis Date :
        </div> <div class="col-4">
          <input
            
            class="inputDisplay"
            disabled
          >
        </div> 
      </div> -->

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="city"
              disabled
              label="City"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="postalCode"
              disabled
              label="Postal Code"
            />
          </div>


          <div class="col-2">
            <ADSTextInput
              v-model="country"
              disabled
              label="Country"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="state"
              disabled
              label="Province/State"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="referralDecisionDate"
              disabled
              label="Referral Received Date"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="referralDecision"
              disabled
              label="Referral Decision"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="referralReceivedDate"
              disabled
              label="Referral Decision Date"
            />
          </div>
          
        </div>

        <!-- <div class="row">
        <div class="col-4">
          Recipient Coordinator :
        </div> <div class="col-4">
          <input
            
            class="inputDisplay"
            disabled
          >
        </div> 
      </div> -->

        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="referralDecisionReason"
              class="referralDecisionReason"
              disabled
              label="Referral Decision Reason (Declined or  Cancelled)"
            />
          </div>

          <div class="col-3">
            <ADSTextInput
              v-model="referralDecisionComments"
              class="referralDecisionReason"
              disabled
              label="Referral Decision Comments"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="consultationDate"
              disabled
              label="Consultation Date"
            />
          </div>
        </div>

        <!-- <div class="row">
        <div class="col-4">
          Recipient Coordinator  :
        </div> <div class="col-4">
          <input
            
            class="inputDisplay"
            disabled
          >
        </div> 
      </div> -->


        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="consultationDecision"
              disabled
              label="Consultation Decision"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="reasonCancelled"
              disabled
              label="Reason (for Cancelled)"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="reasonDelayed"
              disabled
              label="Reason (for Delayed)"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="consultationCancelledDate"
              disabled
              label="Consultation Cancelled Date"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="primaryTransplantPhysician"
              class="primaryTransplantPhysician"
              disabled
              label="Primary Transplant Physician"
            />
          </div>
          <!-- <div class="col-4">
          <div class="fieldName">
            Primary Transplant Physician
          </div>
          <input
            v-model="primaryTransplantPhysician"
            class="inputDisplay"
            disabled
          >
        </div>  -->

          <div class="col-2">
            <ADSTextInput
              v-model="consultationDelayStartDate"
              disabled
              label="Consultation Delay Start Date"
            />
          </div>

          <!-- <div class="col-3">
          <div class="fieldName">
            ConsultationDelay Start Date
          </div>
          <input
            v-model="consultationDelayStartDate"
            class="inputDisplay"
            disabled
          >
        </div> -->

          <div class="col-2">
            <ADSTextInput
              v-model="consultationDelayEndDate"
              disabled
              label="Consultation Delay End Date"
            />
          </div>

        <!-- <div class="col-2">
          <div class="fieldName">
            Consultation Delay End Date
          </div>
          <input
            v-model="consultationDelayEndDate"
            class="inputDisplay"
            disabled
          >
        </div> -->
        </div>

        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="consultationComments"
              class="consultationComments"
              disabled
              label="Consultation Comments"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="assessmentDate"
              disabled
              label="Assessment Date"
            />
          </div>

          <div class="col-3">
            <ADSTextInput
              v-model="assessmentDecision"
              class="assessmentDecision"
              disabled
              label="Assessment Decision"
            />
          </div>
        </div>

        <!-- <div class="row">
        <div class="col-4">
          Recipient Coordinator  :
        </div> <div class="col-4">
          <input
            
            class="inputDisplay"
            disabled
          >
        </div> 
      </div> -->

        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="reasonAssessmentCancelled"
              class="reasonAssessmentCancelled"
              disabled
              label="Reason (for Assessment Cancelled)"
            />
          </div>

          <div class="col-3">
            <ADSTextInput
              v-model="reasonRecipientNotEligible"
              class="reasonRecipientNotEligible"
              disabled
              label="Reason (for Decision for Recipient not Eligible)"
            />
          </div>

          <div class="col-3">
            <ADSTextInput
              v-model="reasonFurtherTreatment"
              class="reasonRecipientNotEligible"
              disabled
              label="Reason (for Further Treatment or Further Testing Required)"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="other"
              class="other"
              disabled
              label="Other"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="absoluteContraindication"
              disabled
              label="Absolute Contraindication"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="relativeContraindication"
              class="relativeContraindication"
              disabled
              label="Relative Contraindications"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="comments"
              class="comments"
              disabled
              label="Comments"
            />
          </div>
        <!-- <div class="col-3">
          <div class="fieldName">
            Comments
          </div>
          <input
            v-model="comments"
            class="inputDisplaycomments"
            disabled
          >
        </div>  -->
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';

export default {
  name: "ReferralConsultationSectionDetails",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      transplantProgram: this.getTransplantProgram( this.patientBundle ),
      recipientCoordinator: this.getRecipientCoordinator( this.patientBundle ),
      referralReceivedDate: this.getReferralReceivedDate( this.patientBundle ),
      referralDecisionDate: this.getReferralDecisionDate( this.patientBundle ),
      referralDecision: this.getReferralDecision( this.patientBundle ),
      referralDecisionReason: this.getReferralDecisionReason( this.patientBundle ),
      referralDecisionComments: this.getReferralDecisionComments( this.patientBundle ),
      primaryDiagnosis: this.getPrimaryDiagnosis( this.patientBundle ),
      primaryDiagnosisDate: this.getPrimaryDiagnosisDate( this.patientBundle ),
      referringOrganizationName: this.getReferringOrganizationName( this.patientBundle ),
      referringOrganizationType: this.getReferringOrganizationType( this.patientBundle ),
      otherOrganizationType: this.getOtherOrganizationType( this.patientBundle ),
      referringHealthCareProfessionalType: this.getReferringHealthCareProfessionalType( this.patientBundle ),
      consultationDate: this.getConsultationDate( this.patientBundle ),
      consultationCancelledDate: this.getConsultationCancelledDate( this.patientBundle ),
      consultationDecision: this.getConsultationDecision( this.patientBundle ),
      reasonCancelled: this.getReasonCancelled( this.patientBundle ),
      reasonDelayed: this.getReasonDelayed( this.patientBundle ),
      primaryTransplantPhysician: this.getPrimaryTransplantPhysician( this.patientBundle ),
      consultationDelayStartDate: this.getConsultationDelayStartDate( this.patientBundle ),
      consultationDelayEndDate: this.getConsultationDelayEndDate( this.patientBundle ),
      consultationComments: this.getConsultationComments( this.patientBundle ),
      assessmentDate: this.getAssessmentDate( this.patientBundle ),
      assessmentDecision: this.getAssessmenDecision( this.patientBundle ),
      reasonAssessmentCancelled: this.getReasonAssessmentCancelled( this.patientBundle ),
      reasonRecipientNotEligible: this.getReasonRecipientNotEligible( this.patientBundle ),
      reasonFurtherTreatment: this.getReasonFurtherTreatment( this.patientBundle ),
      other: this.getOther( this.patientBundle ),
      absoluteContraindication: this.getAbsoluteContraindication( this.patientBundle ),
      relativeContraindication: this.getRelativeContraindication( this.patientBundle ),
      comments: this.getComments( this.patientBundle ),
      careTeamID: this.getCareTeamID( this.patientBundle ),
      firstName: this.getFirstName( this.patientBundle ),
      lastName: this.getLastName( this.patientBundle ),
      address: this.getAddress( this.patientBundle ),
      city: this.getCity( this.patientBundle ),
      country: this.getCountry( this.patientBundle ),
      postalCode: this.getPostalCode( this.patientBundle ),
      state: this.getState( this.patientBundle ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    getTransplantProgram( patientBundle ) {
      let episodeOfCare = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'EpisodeOfCare' ) );
      if( episodeOfCare && episodeOfCare[ 0 ] && episodeOfCare[ 0 ][ 0 ] ) {
        for( let item of episodeOfCare[ 0 ][ 0 ]?.resource?.extension ) {
             if( item.url?.includes( "transplant-center" ) ) {
              return item.valueString;
             }
        
      }
      }
    },
    getRecipientCoordinator( patientBundle ) {
      let episodeOfCare = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'EpisodeOfCare' ) );
      if( episodeOfCare && episodeOfCare[ 0 ] && episodeOfCare[ 0 ][ 0 ] ) {
        for( let item of episodeOfCare[ 0 ][ 0 ]?.resource?.extension ) {
             if( item.url?.includes( "transplant-organ-coordinator" ) ) {
              let coordinator = item.extension.filter( ( n ) => ( n.url === 'coordinator' ) );
              if( coordinator && coordinator[ 0 ] )
              return _.get( coordinator[0], 'valueReference.display' )
             }
        
      }
      }
    },
    getCareTeamID( patientBundle ) {
      let episodeOfCare = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'EpisodeOfCare' ) );
      if( episodeOfCare && episodeOfCare[ 0 ] && episodeOfCare[ 0 ][ 0 ] ) {
       return _.get( episodeOfCare[ 0 ][ 0 ], 'resource.team[0].reference' ) .replace( 'CareTeam/', '' );
      }
    },
    getReferralReceivedDate( patientBundle ) {
      let episodeOfCare = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'EpisodeOfCare' ) );
      if( episodeOfCare && episodeOfCare[ 0 ] && episodeOfCare[ 0 ][ 0 ] ) {
        for( let item of episodeOfCare[ 0 ][ 0 ]?.resource?.extension ) {
             if( item.url?.includes( "transplant-event-referral-date" ) ) {
              return item.valueDate;
             }
      }
      }
    },
    getReferralDecisionDate( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let referralDecisionDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#335' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( referralDecisionDate && referralDecisionDate[ 0 ] ) {
        return _.get( referralDecisionDate[0], 'resource.component[0].valueDateTime' );
      } 
      }
    },
    getReferralDecision( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let referralDecision = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#334' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( referralDecision && referralDecision[ 0 ] ) {
        return _.get( referralDecision[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getReferralDecisionReason( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let referralDecisionReason = observation[ 0 ].filter( ( n ) => ( ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#336' || _.get( n, 'resource.code.coding[0].code' ) === 'TXP#16574' ) && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
        if( referralDecisionReason && referralDecisionReason[ 0 ] ) {
        return _.get( referralDecisionReason[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getReferralDecisionComments( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let referralDecisionComments = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#323' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( referralDecisionComments && referralDecisionComments[ 0 ] ) {
        return _.get( referralDecisionComments[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getPrimaryDiagnosis( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let primaryDiagnosis = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#337' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( primaryDiagnosis && primaryDiagnosis[ 0 ]?.resource?.code?.text ) {
        return _.get( primaryDiagnosis[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getPrimaryDiagnosisDate( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let primaryDiagnosis = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#338' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( primaryDiagnosis && primaryDiagnosis[ 0 ] ) {
        return _.get( primaryDiagnosis[0], 'resource.component[0].valueDateTime' );
      } 
      }
    },
    getReferringOrganizationName( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let referringOrganizationName = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#276' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( referringOrganizationName && referringOrganizationName[ 0 ] ) {
        return _.get( referringOrganizationName[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getReferringOrganizationType( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let referringOrganizationName = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#277' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( referringOrganizationName && referringOrganizationName[ 0 ] ) {
        return _.get( referringOrganizationName[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getOtherOrganizationType( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) )
      if( observation && observation[ 0 ] ) {
      let otherOrganizationType = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#278' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( otherOrganizationType && otherOrganizationType[ 0 ] ) {
        return _.get( otherOrganizationType[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getReferringHealthCareProfessionalType( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) )
      if( observation && observation[ 0 ] ) {
      let referringHealthCareProfessionalType = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#340' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( referringHealthCareProfessionalType && referringHealthCareProfessionalType[ 0 ] ) {
        return _.get( referringHealthCareProfessionalType[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getConsultationDate( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) )
      if( observation && observation[ 0 ] ) {
      let consultationDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#279' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( consultationDate && consultationDate[ 0 ] ) {
        return _.get( consultationDate[0], 'resource.component[0].valueDateTime' );
      } 
      }
    },
    getConsultationCancelledDate( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) )
      if( observation && observation[ 0 ] ) {
      let consultationDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#415' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( consultationDate && consultationDate[ 0 ] ) {
        return _.get( consultationDate[0], 'resource.component[0].valueDateTime' );
      } 
      }
    },
    getConsultationDecision( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) )
      if( observation && observation[ 0 ] ) {
      let consultationDecision = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#273' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( consultationDecision && consultationDecision[ 0 ] ) {
        return _.get( consultationDecision[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getReasonCancelled( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let reasonCancelled = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#274' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( reasonCancelled && reasonCancelled[ 0 ] ) {
        return _.get( reasonCancelled[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getReasonDelayed( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let reasonDelayed = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#275' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( reasonDelayed && reasonDelayed[ 0 ] ) {
        return _.get( reasonDelayed[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getPrimaryTransplantPhysician( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let primaryTransplantPhysician = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#351' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( primaryTransplantPhysician && primaryTransplantPhysician[ 0 ] ) {
        return _.get( primaryTransplantPhysician[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getConsultationDelayStartDate( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let consultationDelayStartDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#282' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( consultationDelayStartDate && consultationDelayStartDate[ 0 ] ) {
        return _.get( consultationDelayStartDate[0], 'resource.component[0].valueDateTime' );
      } 
      }
    },
    getConsultationDelayEndDate( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let consultationDelayEndDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#283' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( consultationDelayEndDate && consultationDelayEndDate[ 0 ] ) {
        return _.get( consultationDelayEndDate[0], 'resource.component[0].valueDateTime' );
      } 
      }
    },
    getConsultationComments( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let consultationComments = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#284' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( consultationComments && consultationComments[ 0 ] ) {
        return _.get( consultationComments[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getAssessmentDate( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let assessmentDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#285' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( assessmentDate && assessmentDate[ 0 ]?.resource?.code?.text ) {
        return _.get( assessmentDate[0], 'resource.component[0].valueDateTime' );
      } 
      }
    },
    getAssessmenDecision( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let assessmentDecision = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#287' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( assessmentDecision && assessmentDecision[ 0 ] ) {
        return _.get( assessmentDecision[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getReasonAssessmentCancelled( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let reasonAssessmentCancelled = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#288' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( reasonAssessmentCancelled && reasonAssessmentCancelled[ 0 ] ) {
        return _.get( reasonAssessmentCancelled[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getReasonRecipientNotEligible( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let reasonRecipientNotEligible = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#289' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( reasonRecipientNotEligible && reasonRecipientNotEligible[ 0 ] ) {
        return _.get( reasonRecipientNotEligible[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getReasonFurtherTreatment( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let reasonRecipientNotEligible = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#290' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( reasonRecipientNotEligible && reasonRecipientNotEligible[ 0 ] ) {
        return _.get( reasonRecipientNotEligible[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getOther( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let other = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#327' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( other && other[ 0 ] ) {
        return _.get( other[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getAbsoluteContraindication( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let absoluteContraindication = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#291' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( absoluteContraindication && absoluteContraindication[ 0 ] ) {
        return _.get( absoluteContraindication[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getRelativeContraindication( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let relativeContraindication = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#292' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( relativeContraindication && relativeContraindication[ 0 ] ) {
        return _.get( relativeContraindication[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getComments( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let comments = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#293' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( comments && comments[ 0 ] ) {
        return _.get( comments[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getFirstName( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if ( observation && observation[0] ) {
        let firstName = observation[0].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#341' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) );
        if ( firstName && firstName[0] ) {
          return _.get( firstName[0], 'resource.component[0].valueString' );
        }
      }
    },
    getLastName( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if ( observation && observation[0] ) {
        let lastName = observation[0].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#342' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) );
        if ( lastName && lastName[0] ) {
          return _.get( lastName[0], 'resource.component[0].valueString' );
        }
      }
    },
    getAddress( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if ( observation && observation[0] ) {
        let lastName = observation[0].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#352' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) );
        if ( lastName && lastName[0] ) {
          return _.get( lastName[0], 'resource.component[0].valueString' );
        }
      }
    },
    getCity( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if ( observation && observation[0] ) {
        let lastName = observation[0].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#353' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) );
        if ( lastName && lastName[0] ) {
          return _.get( lastName[0], 'resource.component[0].valueString' );
        }
      }
    },
    getCountry( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if ( observation && observation[0] ) {
        let country = observation[0].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#354' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) );
        if ( country && country[0] ) {
          return _.get( country[0], 'resource.component[0].valueString' );
        }
      }
    },
    getPostalCode( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if ( observation && observation[0] ) {
        let country = observation[0].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#356' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) );
        if ( country && country[0] ) {
          return _.get( country[0], 'resource.component[0].valueString' );
        }
      }
    },
    getState( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if ( observation && observation[0] ) {
        let country = observation[0].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#355' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) );
        if ( country && country[0] ) {
          return _.get( country[0], 'resource.component[0].valueCodeableConcept.text' );
        }
      }
    },
  },
};
</script>

<style scoped>

/* .card {
  height: 1350px;
} */

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}

.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 1350px;
  width: 1400px;
  /* overflow: scroll; */
  padding-left: 10px;
  padding-top: 5px;
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
}

.inputDisplayTransplantProgram {
  border-style: solid;
  width: 350px;
  background-color: #F2F2F2;
}

.inputDisplayOtherOrganizationType {
  border-style: solid;
  width: 350px;
  background-color: #F2F2F2;
}

.inputDisplayreferralDecisionReason {
  border-style: solid;
  width: 350px;
  background-color: #F2F2F2;
}

.inputDisplayreferralDecisionComments {
  border-style: solid;
  width: 300px;
  background-color: #F2F2F2;
}

.inputDisplayreasonCancelled {
  border-style: solid;
  width: 300px;
  background-color: #F2F2F2;
}

.inputDisplayreasonDelayed {
  border-style: solid;
  width: 300px;
  background-color: #F2F2F2;
}

.inputDisplayconsultationComments{
  border-style: solid;
  width: 300px;
  background-color: #F2F2F2;
}

.inputDisplayassessmentDecision{
  border-style: solid;
  width: 300px;
  background-color: #F2F2F2;
}

.inputDisplaycareTeamID{
  border-style: solid;
  width: 430px;
  background-color: #F2F2F2;
}

.inputDisplayreasonAssessmentCancelled {
  border-style: solid;
  width: 300px;
  background-color: #F2F2F2;
}

.inputDisplayreasonRecipientNotEligible {
  border-style: solid;
  width: 300px;
  background-color: #F2F2F2;
}

.inputDisplayother {
  border-style: solid;
  width: 450px;
  background-color: #F2F2F2;
}

.inputDisplaycomments {
  border-style: solid;
  width: 300px;
  background-color: #F2F2F2;
}

.inputDisplayrelativeContraindication {
  border-style: solid;
  width: 300px;
  background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  padding-top: 12.5px;
  padding-bottom: 2.5px;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

:deep(.transplantProgram .afflo-ds-form-control) {
  width: 400px;
} 

:deep(.otherOrganizationType .afflo-ds-form-control) {
  width: 350px;
}

:deep(.careTeamID .afflo-ds-form-control) {
  width: 460px;
}  

:deep(.referralDecisionReason .afflo-ds-form-control) {
  width: 310px;
} 

:deep(.primaryTransplantPhysician .afflo-ds-form-control) {
  width: 350px;
}

:deep(.consultationComments .afflo-ds-form-control) {
  width: 280px;
} 

:deep(.assessmentDecision .afflo-ds-form-control) {
  width: 310px;
} 

:deep(.reasonAssessmentCancelled .afflo-ds-form-control) {
  width: 330px;
}

:deep(.other .afflo-ds-form-control) {
  width: 420px;
} 

:deep(.relativeContraindication .afflo-ds-form-control) {
  width: 250px;
}

:deep(.comments .afflo-ds-form-control) {
  width: 330px;
}

</style>
